import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import { useForm, useFormState } from '../../../../packages/kiti/components/form/form/FormHandler'
import Text, { Title } from '../../../../packages/kiti/components/presentation/Text'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'
import Separator from '../../../../packages/kiti/components/helpers/Separator'
import Select from '../../../../packages/kiti/components/form/Select'
import DateInput from '../../../../components/form/date/DateInput'
import Marker from '../../../../packages/kiti/components/shapes/Marker'
import NumberInput from '../../../../packages/kiti/components/form/NumberInput'
import FlexGrid from '../../../../components/structure/FlexGrid'
import moment from 'moment'
import WeekDays from '../../../../packages/kiti/components/form/date/Weekdays'

const RepeatEvery = () => {
  const { t } = useTranslation('routines')
  const { handleChangeIn, form } = useFormState()

  const afterChange = () => {
    handleChangeIn(['weekday'], null)
  }

  const options = [
    { id: 'day', name: t('frequencyOptions.day') },
    { id: 'week', name: t('frequencyOptions.week') },
    { id: 'year', name: t('frequencyOptions.year') }
  ]
  return (
    <Grid gap={0.5}>
      <Col width={4.5}>
        <FormItem
          disabled={form.id}
          ignoreLabel
          field={'frequencyIndex'}
          Input={NumberInput}
          onlyInt
          allowNoValue
          afterChange={afterChange}
        />
      </Col>
      <Col width={11}>
        <FormItem
          disabled={form.id}
          ignoreLabel
          disableEmptyOption
          field={'frequencyType'}
          Input={Select}
          options={options}
          afterChange={afterChange}
        />
      </Col>
    </Grid>
  )
}

const FrequencySection = () => {
  const { t } = useTranslation('routines')
  const form = useForm()
  const { handleChangeIn } = useFormState()

  return (
    <>
      <>
        <Separator weight={2} />
        <Title size="small" bold color="dark3">
          {t('customizeRecurrence')}
        </Title>
        <Separator weight={2} />
        {t('repeatEvery')}
        <Separator weight={2} />
        <FormItem ignoreLabel={true} field="frequency" Input={RepeatEvery} />
        <Separator weight={2} />
      </>
      {form.frequencyType?.id === 'week' && (
        <>
          {t('repeat')}:
          <Separator weight={2} />
          <WeekDays disabled={form.id} />
          <Separator weight={2} />
        </>
      )}

      <>
        <FlexGrid gutter={0.2} justify="left" direction={'column'} align="start">
          <Text>{t('startsAt')}</Text>
          <Text>{form.id && moment(form['initialDate']).format('DD/MM/YYYY')}</Text>
          {!form.id && <FormItem value={form['initialDate']} field={'initialDate'} Input={DateInput} />}
        </FlexGrid>
      </>
      <Separator weight={2} />
      <>
        <Text>{t('endsAt')}</Text>
        <Separator weight={2} />
        {!!form.id && form['until'] === 'never' && <Text>{t('never')}</Text>}
        {!!form.id && form['until'] !== 'never' && <Text>{moment(form['until']).format('DD/MM/YYYY')}</Text>}
        {!form.id && (
          <>
            <FlexGrid gutter={0.2} justify="left">
              <Marker circle value={form['until'] === 'never'} onChange={() => handleChangeIn(['until'], 'never')} />
              <Text>{t('never')}</Text>
            </FlexGrid>
            <FlexGrid gutter={0.2} justify="left">
              <Marker
                circle
                value={form['until'] !== 'never'}
                onChange={() => handleChangeIn(['until'], form['initialDate'])}
              />
              <Text>{t('on')}</Text>

              <FormItem
                value={form['until'] === 'never' ? null : new Date(form['until'])}
                field={'until'}
                Input={DateInput}
                disabled={form['until'] === 'never'}
              />
            </FlexGrid>
          </>
        )}
      </>
    </>
  )
}

export default FrequencySection
